import {
  convertFromLenderInformationResponseToLenderInformationData,
  ILenderInformationData,
  ILenderInformationResponse,
} from '../../types/lenders/ILenderInformation';
import {
  convertILenderCompanyResponseToILenderCompanyData,
  ILenderCompanyData,
  ILenderCompanyResponse,
} from '../../types/lenders/ILenderCompany';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';

export const getLenderInfoAsync = async (lenderId: string): Promise<ILenderInformationData> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<ILenderInformationResponse>(`/timber/api/internal/public_lender_companies/${lenderId}`)
    .then((response) => convertFromLenderInformationResponseToLenderInformationData(response.data))
    .catch(axiosErrorHandler);

export const getAllLendersAsync = async (): Promise<ILenderCompanyData[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<ILenderCompanyResponse[]>(`/timber/api/internal/lender_companies`)
    .then((response) => response.data.map(convertILenderCompanyResponseToILenderCompanyData))
    .catch(axiosErrorHandler);
